<template>
  <BaseTypeNewForm
    base-type="accommodations"
    title="Neue Unterkunft anlegen"
    subtitle="Vergeben Sie einen Titel – Details, Bilder und Ausstattung pflegen Sie anschließend im Editor."
    legend="Unterkunft benennen"
    input-label="Titel der Unterkunft"
    hint="Tipp: Wählen Sie einen klaren, eindeutigen Namen, damit Sie Ihre Unterkunft in der Übersicht leicht wiederfinden."
    submit-label="Unterkunft anlegen und bearbeiten"
    cancel-route-name="accommodations.index"
    :edit-route-name="editRouteName"
    require-category
    category-legend="Kategorie auswahlen"
    category-layout="rows"
  />
</template>

<script>
import BaseTypeNewForm from "@/components/base_type/BaseTypeNewForm.vue";
import {ROUTES} from "@/stores/constants";

export default {
  components: {
    BaseTypeNewForm,
  },
  computed: {
    editRouteName() {
      return ROUTES.ACCOMMODATIONS.EDIT
    },
  },
}
</script>
